<template>
    <div class="side-bar-content">
        <router-link to="/home">
            <div class="side-bar-logo">
                <!--<img src="../assets/powerbee.png" alt="logo">-->
                蜂电科技
            </div>
        </router-link>
        <div class="side-bar">
            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" :router="isRouter"  :collapse="isCollapse">
                <el-menu-item index="/purse" v-if="isChild==0">
                    <i class="el-icon-menu"></i>
                    <span slot="title">我的钱包</span>
                </el-menu-item>

                <el-menu-item index="/personal">
                    <i class="el-icon-location-outline"></i>
                    <span slot="title">个人信息</span>
                </el-menu-item>

                <el-menu-item index="/setup">
                    <i class="el-icon-setting"></i>
                    <span slot="title">参数设置</span>
                </el-menu-item>

                <!--<el-menu-item index="/help">-->
                    <!--<i class="el-icon-setting"></i>-->
                    <!--<span slot="title">帮助文档</span>-->
                <!--</el-menu-item>-->

            </el-menu>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sidebar1",
        data() {
            return {
                isCollapse: false,
                isRouter:true,
                isChild: window.localStorage.isChild,

            }
        },
        methods:{

        }
    }
</script>

<style scoped>
    .side-bar-content {
        width: 1.4rem;
        background-color: #303e51;
        color: #ffffff;
        height: 100%;
    }

    .side-bar-logo {
        width: 100%;
        height: 0.25rem;
        text-align: center;
        font-size:0.2rem;
        margin:0.1rem 0.2rem 0.1rem 0rem;
        color: #fff;
    }

    .side-bar {
        margin-top: 0.15rem;
    }

    .side-bar, .side-bar > ul {
        height: 100%;
        color: #303e51;
        border: 0;
    }

    .el-menu-vertical-demo{
        background-color: #303e51;
    }

    .el-menu-vertical-demo li:hover{
        background-color: #40536c !important;
        color: #ffffff;
    }

    i{
        color: #e3e3e3;
    }
    .el-menu-vertical-demo li {
        color: #e3e3e3;
        padding: 0 !important;
        padding-left: 0.06rem !important;
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-size: 16px;
    }

    .el-menu-vertical-demo .el-menu-item.is-active {
        background-color: #409EFF !important;
        color: #ffffff;
    }
</style>